(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sj-fit-note"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sj-fit-note')) return;
    class SjFitNote extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        this.addEventListener('click', (event) => {
          const guide = event.target instanceof Element ? event.target.closest('[data-sjf-guide]') : null;
          if (!guide) return;
          const app = document.querySelector('.scr-open-size-chart');
          if (app) {
            event.preventDefault();
            app.click();
          }
        });
        const form = this.querySelector('[data-sjf-form]');
        if (form) form.addEventListener('submit', (event) => this.submit(event, form));
      }

      say(form, text, isError) {
        const msg = form.querySelector('[data-sjf-msg]');
        if (!msg) return;
        msg.className = 'sjf__msg' + (isError ? ' is-error' : '');
        msg.textContent = text;
      }

      async submit(event, form) {
        event.preventDefault();
        const size = form.querySelector('input[type="radio"]:checked');
        const email = form.querySelector('input[type="email"]');
        const button = form.querySelector('button[type="submit"]');
        if (!size) { this.say(form, 'Pick your size first.', true); return; }
        const value = email ? email.value.trim() : '';
        if (!value || (email && !email.checkValidity()) || value.indexOf('@') < 1) {
          this.say(form, 'Please check your email address.', true);
          if (email) email.focus();
          return;
        }
        if (button) button.disabled = true;
        this.say(form, '', false);
        const body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Size waitlist (product page)',
              profile: { data: { type: 'profile', attributes: { email: value, properties: { sj_size_waitlist: size.value, sj_size_waitlist_product: this.dataset.product || '' } } } }
            },
            relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
          }
        };
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.dataset.company || ''), {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2025-01-15' },
            body: JSON.stringify(body)
          });
          if (!response.ok) throw new Error('status ' + response.status);
          const done = document.createElement('p');
          done.className = 'sjf__done';
          done.setAttribute('role', 'status');
          done.textContent = "You're on the list for AU " + size.value + ". We'll email you first if we make it.";
          form.replaceChildren(done);
        } catch (error) {
          this.say(form, "Sorry, that didn't go through. Please try again.", true);
          if (button) button.disabled = false;
        }
      }
    }
    customElements.define('sj-fit-note', SjFitNote);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sj-pair-nudge"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sj-pair-nudge')) return;
    const routes = () => (window.Theme && window.Theme.routes) || {};
    let eventsModule = null;
    const loadEvents = async () => {
      if (eventsModule) return eventsModule;
      try { eventsModule = await import('@shopify/events'); } catch (e) { eventsModule = {}; }
      return eventsModule;
    };

    class SjPairNudge extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        this.addEventListener('click', this.onClick);
      }

      say(text, isError) {
        const msg = this.querySelector('[data-sjp-msg]');
        if (!msg) return;
        msg.className = 'sjp__msg' + (isError ? ' is-error' : '');
        msg.textContent = text;
      }

      pickedSize() {
        const picker = document.querySelector('variant-picker[data-product-id="' + this.dataset.productId + '"]');
        if (!picker) return null;
        const input = picker.querySelector('fieldset input:checked');
        if (input) return input.value;
        const select = picker.querySelector('select');
        return select ? select.value : null;
      }

      async add(btn, variantId, label) {
        const r = routes();
        const addUrl = (r.cart_add_url || '/cart/add') + '.js';
        const cartUrl = (r.cart_url || '/cart') + '.js';
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        const { CartLinesUpdateEvent } = await loadEvents();
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
        const body = new FormData();
        body.append('id', variantId);
        body.append('quantity', '1');
        if (sectionIds.length) {
          body.append('sections', sectionIds.join(','));
          body.append('sections_url', window.location.pathname);
        }
        let deferred = null;
        if (CartLinesUpdateEvent) {
          deferred = CartLinesUpdateEvent.createPromise();
          btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
        }
        try {
          const response = await fetch(addUrl, { method: 'POST', body, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } });
          const data = await response.json();
          const failed = !response.ok || Boolean(data.status);
          const ajaxCart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((res) => res.json());
          if (deferred) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: { didError: failed, items: ajaxCart.items, source: 'sj-pair-nudge', sourceId: variantId, itemCount: 1, productId: this.dataset.productId, sections: failed ? undefined : data.sections },
            });
          }
          if (failed) {
            this.say(data.description || data.message || 'Sorry, that could not be added.', true);
            return;
          }
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 1800);
          const msg = this.querySelector('[data-sjp-msg]');
          if (!msg) return;
          msg.className = 'sjp__msg';
          msg.textContent = '';
          const deal = ajaxCart.item_count >= 2 ? ' 20% off is applied in your bag. ' : ' Add yours too and 20% comes off both. ';
          msg.append(document.createTextNode('Added ' + label + '.' + deal));
          const bag = document.createElement('a');
          bag.href = r.cart_url || '/cart';
          bag.textContent = 'View bag';
          msg.append(bag);
        } catch (error) {
          if (deferred) deferred.reject(error);
          this.say('Something went wrong. Please try again.', true);
        } finally {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      }

      onClick = async (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const sizeBtn = target.closest('[data-sjp-add]');
        if (sizeBtn && !sizeBtn.disabled && !sizeBtn.classList.contains('is-loading')) {
          await this.add(sizeBtn, sizeBtn.dataset.sjpAdd, 'the ' + sizeBtn.dataset.name + ', size ' + sizeBtn.dataset.size);
          return;
        }
        const print = target.closest('[data-sjp-second]');
        if (!print || print.classList.contains('is-loading')) return;
        const size = this.pickedSize();
        if (!size) { this.say('Pick your size above first.', true); return; }
        const match = Array.from(print.querySelectorAll('i[data-id]')).find((i) => i.dataset.size === size);
        if (!match || match.dataset.ok !== 'true') {
          this.say(print.dataset.name + ' is sold out in size ' + size + '. Try another print.', true);
          return;
        }
        await this.add(print, match.dataset.id, print.dataset.name + ', size ' + size);
      };
    }

    customElements.define('sj-pair-nudge', SjPairNudge);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sj-quick-sizes"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sj-quick-sizes')) return;
    const routes = () => (window.Theme && window.Theme.routes) || {};
    let eventsModule = null;
    const loadEvents = async () => {
      if (eventsModule) return eventsModule;
      try { eventsModule = await import('@shopify/events'); } catch (e) { eventsModule = {}; }
      return eventsModule;
    };

    class SjQuickSizes extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close(true);
        });
      }

      open() {
        document.querySelectorAll('sj-quick-sizes.is-open').forEach((el) => { if (el !== this) el.close(false); });
        this.classList.add('is-open');
        const btn = this.querySelector('[data-sjq-open]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        const first = this.querySelector('.sjq__size:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }

      close(focusButton) {
        this.classList.remove('is-open');
        const btn = this.querySelector('[data-sjq-open]');
        if (btn) {
          btn.setAttribute('aria-expanded', 'false');
          if (focusButton) btn.focus({ preventScroll: true });
        }
      }

      setMsg(text, isError) {
        const msg = this.querySelector('[data-sjq-msg]');
        if (!msg) return;
        msg.className = 'sjq__msg' + (isError ? ' is-error' : '');
        msg.textContent = text;
      }

      variantFor() {
        const holder = this.querySelector('[data-sjq-variants]');
        if (!holder) return null;
        const rows = Array.from(this.querySelectorAll('.sjq__row'));
        const picks = [];
        this.querySelectorAll('[data-sjq-opt][aria-pressed="true"]').forEach((b) => { picks[Number(b.dataset.sjqOpt)] = b.dataset.value; });
        if (picks.filter((p) => p !== undefined).length < rows.length) return { pending: true };
        const match = Array.from(holder.querySelectorAll('[data-v]')).find((i) => i.dataset.o1 === picks[0] && (rows.length < 2 || i.dataset.o2 === picks[1]));
        if (!match) return { missing: true };
        return {
          id: match.dataset.v,
          ok: match.dataset.ok === 'true',
          size: rows.map((row) => row.querySelector('.sjq__label').textContent.trim().toLowerCase() + ' ' + ((row.querySelector('[aria-pressed="true"]') || {}).textContent || '').trim()).join(', '),
        };
      }

      async add(btn, variantId, size) {
        const r = routes();
        const addUrl = (r.cart_add_url || '/cart/add') + '.js';
        const cartUrl = (r.cart_url || '/cart') + '.js';
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        const { CartLinesUpdateEvent } = await loadEvents();
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
        const body = new FormData();
        body.append('id', variantId);
        body.append('quantity', '1');
        if (sectionIds.length) {
          body.append('sections', sectionIds.join(','));
          body.append('sections_url', window.location.pathname);
        }
        let deferred = null;
        if (CartLinesUpdateEvent) {
          deferred = CartLinesUpdateEvent.createPromise();
          btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
        }
        try {
          const response = await fetch(addUrl, { method: 'POST', body, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } });
          const data = await response.json();
          const failed = !response.ok || Boolean(data.status);
          if (deferred) {
            const ajaxCart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((res) => res.json());
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: { didError: failed, items: ajaxCart.items, source: 'sj-quick-sizes', sourceId: variantId, itemCount: 1, productId: this.dataset.productId, sections: failed ? undefined : data.sections },
            });
          }
          if (failed) {
            this.setMsg(data.description || data.message || 'Sorry, that size could not be added.', true);
            return false;
          }
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 1800);
          this.showAdded(size);
          return true;
        } catch (error) {
          if (deferred) deferred.reject(error);
          this.setMsg('Something went wrong. Please try again.', true);
          return false;
        } finally {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      }

      showAdded(size) {
        const msg = this.querySelector('[data-sjq-msg]');
        if (!msg) return;
        const sizeText = size ? (size.indexOf(' ') > -1 ? ', ' + size : ', size ' + size) : '';
        // Black Friday 2026: the two-piece 20% offer is paused while the sale runs (5pm 1 Nov to 15 Dec AEDT).
        const now = Date.now();
        const bf = now >= Date.parse('2026-11-01T17:00:00+11:00') && now < Date.parse('2026-12-16T00:00:00+11:00');
        msg.className = 'sjq__msg';
        msg.textContent = '';
        msg.append(document.createTextNode('Added' + sizeText + '. '));
        if (this.dataset.partnerUrl) {
          const match = document.createElement('a');
          match.href = this.dataset.partnerUrl;
          match.textContent = 'Match it with the ' + this.dataset.partnerKind + (bf ? '' : ', save 20% on both');
          msg.append(match, document.createTextNode(bf ? '. ' : ' '));
        } else if (!bf) {
          msg.append(document.createTextNode('Any two pieces save 20%. '));
        }
        const bag = document.createElement('a');
        bag.href = routes().cart_url || '/cart';
        bag.textContent = 'View bag';
        msg.append(bag);
      }

      onClick = async (event) => {
        event.stopPropagation();
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest('a')) return;
        if (target.closest('[data-sjq-open]')) { this.open(); return; }
        if (target.closest('[data-sjq-close]')) { this.close(true); return; }
        const opt = target.closest('[data-sjq-opt]');
        if (opt) {
          opt.parentElement.querySelectorAll('[data-sjq-opt]').forEach((b) => b.setAttribute('aria-pressed', String(b === opt)));
          const v = this.variantFor();
          if (!v || v.pending) return;
          if (v.missing || !v.ok) { this.setMsg('That size combination is sold out. Try another.', true); return; }
          const ok = await this.add(opt, v.id, v.size);
          if (ok) this.querySelectorAll('[data-sjq-opt]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
          return;
        }
        const btn = target.closest('[data-sjq-add]');
        if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
        await this.add(btn, btn.dataset.sjqAdd, btn.dataset.size);
      };
    }

    customElements.define('sj-quick-sizes', SjQuickSizes);
  })();
  } catch(e) { console.error(e); }
})();

})();
